export const isCustomQuotesProduct = ({ sku }: { sku?: string }) => {
  if (sku && sku === process.env.REACT_APP_CUSTOM_QUOTES_SKU) {
    return true;
  }

  return false;
};
